const reviews = [
  {
    id: 38,
    name: "Susan S.",
    image: "standard",
    city: "Suasalito, CA",
    rating: 5,
    date: "November 12, 2025",
    comment:
      "Ivan did an excellent job replacing the pump on my large fountain. He cleaned each piece, leveled the pieces as he replaced them, and made sure everything was working perfectly. He was very polite and patient, explaining the process and answering all my questions. I was incredibly pleased with my experience with Ivan Fountain.",
  },
  {
    id: 37,
    name: "John M.",
    image: "standard",
    city: "Bay Park, San Diego, CA",
    rating: 5,
    date: "November 11, 2025",
    comment:
      "I called Ivan on a Saturday and left him a message regarding a leak in my fountain that needed repair. He responded immediately and said he was available at 8:30 the following Monday morning to inspect the problem. He of the leak and completed the repair. I could not be more pleased with Ivan's responsiveness and the quality of his work.",
  },
  {
    id: 36,
    name: "Murray G.",
    image: "standard",
    city: "Murrieta, CA",
    rating: 5,
    date: "October 18, 2025",
    comment:
      "Ivan came today and did a wonderful job. I didn't realize that my 20yr old fountain was in such bad shape. He cleaned it, leveled it ( it was way out if wack), filled some cracks and changed my broken pump. Ivan was very pleasant to talk to and answered any questions I had plus gave me a little fountain 101. I was very impressed from start to finish",
  },
  {
    id: 35,
    name: "Susan O.",
    image: "standard",
    city: "Beaumont, CA",
    rating: 5,
    date: "September 12, 2025",
    comment:
      "Just met Ivan, very professional and looked at the issue with our water fall fountain and determined what was causing a leak we had. It seems to have taken care of the issue. Easy and fast fix. I would definitely recommend Ivan Fountain repair. Good guy",
  },
  {
    id: 34,
    name: "Michael O.",
    image: "standard",
    city: "San Diego, CA",
    rating: 5,
    date: "August 29, 2025",
    comment:
      "Ivan has helped us twice with our fountain in the backyard. Each time he did a great job. He is very responsive and very professional. I highly recommend !",
  },
  {
    id: 33,
    name: "Toni F.",
    image: "standard",
    city: "San Diego, CA",
    rating: 5,
    date: "August 19, 2025",
    comment:
      "Ivan came out and gave a good estimate to deep clean my 100-gallon urn fountain and basin. It had not been fully drained and washed in years. He patched some cracks in the basin, saving us many hundreds rather than buy new. As the birds in the neighborhood use it for drinking and bathing, he did not use any chemicals. No need! He and his helper took everything apart and power washed it. Even the river rocks on top of the basin. I watched the process and Ivan is efficient, careful, and thorough. A true professional. He made sure I was pleased with all before finishing. I like that I got Ivan, the actual owner, and not an unknown crew that showed up. Big plus. The fountain is beautiful and clean like never before. The birds are so happy I have spent last days just watching them enjoy. Will do a deep clean at least once a year going forward with Ivan. Thanks Ivan!",
  },
  {
    id: 32,
    name: "Kyle M.",
    image: "standard",
    city: "San Diego, CA",
    rating: 5,
    date: "August 7, 2025",
    comment:
      "Ivan went above and beyond to help get our fountain in great shape. I hired Ivan and his team for a cleaning, but he also was able to level out the fountain and add in a clicker so I could control turning on and off the fountain without taking it apart.",
  },
  {
    id: 31,
    name: "Terri M.",
    image: "standard",
    city: "San Luis Obisbo, CA",
    rating: 5,
    date: "July 10, 2025",
    comment:
      "Ivan replaced a broken pump and some chewed up wiring on my fountain last year and did a great job. Also sawed an access door to the pump so it wasn't necessary to completely disassemble the heavy concrete fountain in order to get at the pump. This year he gave me some tips over the phone for fixing an issue with my fountain which saved me the cost of a service call for something I was able to do myself. Much appreciated.",
  },
  {
    id: 30,
    name: "Charles S.",
    image: "standard",
    city: "Pala, CA",
    rating: 5,
    date: "July 8, 2025",
    comment:
      "A few months ago, I contacted Ivan to repair one of my fountains. He promptly resolved the issues and the fountain has never worked better in the 16 years I have owned it! I recommend him without reservation.",
  },
  {
    id: 29,
    name: "Souheil H.",
    image: "standard",
    city: "Rancho Palos Verdes,, CA",
    rating: 5,
    date: "July 2, 2025",
    comment:
      "Excellent service, reasonable prices, we have a big fountain with broken pump. They retrieved it from inside the fountain and replaced it with new one. No visible wiring or hoses",
  },
  {
    id: 28,
    name: "Rob R.",
    image: "standard",
    city: "CORONA DL MAR, CA",
    rating: 5,
    date: "July 1, 2025",
    comment:
      "The best fountain service. Showed up and had all parts to fix it the first time. Ivan is great!!",
  },
  {
    id: 27,
    name: "Lisa A.",
    image: "standard",
    city: "Yorba Linda, CA",
    rating: 5,
    date: "June 16, 2025",
    comment:
      "They were on time and extremely respectful of our property. (Our fountain is in the center of our home with French limestone floors requiring great care.) They proceeded to move the very heavy fountain, installed a new pump, put it back together and leveled it perfectly. Ivan also wanted to give us the proper amount of water for the space to avoid over-splashing. They deserve every 5 star rating they have earned.",
  },
  {
    id: 26,
    name: "Renee T.",
    image: "renee",
    city: "Del mar, CA",
    rating: 5,
    date: "June 2, 2025",
    comment:
      "Ivan is the absolute best. I totally recommend him. He cleaned my filthy stainless steel fountain beautifully but when we couldn't get the stainless as shiny as I wanted he came back 3 times to make sure I was satisfied. Where do get that kind of customer service?? His fee was very, very reasonable for his service. You won't make a mistake by hiring Ivan!",
  },
  {
    id: 25,
    name: "Sheryl M.",
    image: "standard",
    city: "Menifee,CA",
    rating: 5,
    date: "may 13, 2025",
    comment:
      "We had a large water feature that had a leaking issue that the original installer could not repair nor figure out what the problem was. I called Ivan in the morning and explained to him what was occurring and he was able to give me an idea of what could potentially be the issue. He came out THE SAME MORNING and knew exactly what the problem was and replaced a faulty pump immediately. He also was able to help us with the splashing problem, all for a very reasonable price. He was extremely knowledgeable and very professional. If I could give more than 5 stars I would!!",
  },
  {
    id: 24,
    name: "Jay M.",
    image: "standard",
    city: "Murrieta, CA",
    rating: 5,
    date: "April 24, 2025",
    comment:
      "5 Golden Stars. Ivan and Edgar were Amazing. I had just bought my home and the previous owner hadnt run the waterfall in years. We didnt even know if the pump worked, but we knew it had leaks because there were weeds coming out of the fountain. Now thanks to Ivan and Edgar, the waterfall is running great without any leaks! Thank you Ivan and Edgar very Much!!!",
  },
  {
    id: 23,
    name: "Heather S.",
    image: "Heather",
    city: "Los Angeles, CA",
    rating: 5,
    date: "February 19, 2025",
    comment:
      "I would give Ivan 50 stars if I could. He is a great, knowledgable resource & he is generous with his time to make sure the job gets done 100% properly. I have a lot of respect for his crew & would recommend him to any fountain enthusiast that needs help! Thank you Ivan!!!",
  },
  {
    id: 22,
    name: "Russell J.",
    image: "standard",
    city: "Southern California",
    rating: 5,
    date: "December 16, 2024",
    comment:
      "I have an old fountain in the courtyard of my office building. The fountain has been a maintenance problem for about 2 years and inoperable for the past fe months. There was talk of making it into a planter, but Ivan and his crew was able to bring the fountain back to life. It's now a central feature of my office building, as it had been in the past.",
  },
  {
    id: 21,
    name: "S N.",
    image: "sn",
    city: "Calabasas, CA",
    rating: 5,
    date: "November 3, 2024",
    comment:
      "Ivan and his guys are top notch. They came and installed two fountains at our new home. From start to finish, they handled everything with care and perfection. I'm very particular when it comes to craftsmanship and finish work and Ivan exceeded my expectations. They were quick and left everything clean, level, and flowing well. Don't bother looking elsewhere (I did the research for you), use Ivan for all your fountain needs!",
  },
  {
    id: 20,
    name: "Seth G.",
    image: "seth",
    city: "Carlsbad, CA",
    rating: 5,
    date: "October 15, 2024",
    comment:
      "Ivan fixed our broken fountain and it is better than new. He is a perfectionist and went above and beyond what I expected. A pool man and an electrician didnt' know how to repair and replace the broken motor. Call Ivan :)",
  },
  {
    id: 19,
    name: "Don T.",
    image: "standard",
    city: "Los Angeles, CA",
    rating: 5,
    date: "October 12, 2024",
    comment:
      "Ivan came out and replaced my fountain pump. He is a true professional and really knows his craft. I highly recommend Ivan for any fountain repair, replacement or maintenance service.",
  },
  {
    id: 18,
    name: "Brandon F.",
    image: "standard",
    city: "Los Angeles, CA",
    rating: 5,
    date: "September 25, 2024",
    comment:
      "Ivan was prompt, fair and delivered a 5 star experience. I would not look anywhere else and give Ivan a call to take care of your needs.",
  },
];

export default reviews;
